var map = {
	"./default.png": "./admin-thumbs/default.png",
	"./s-agenda.png": "./admin-thumbs/s-agenda.png",
	"./s-ankeiler-large.png": "./admin-thumbs/s-ankeiler-large.png",
	"./s-ankeiler.png": "./admin-thumbs/s-ankeiler.png",
	"./s-block-carousel.png": "./admin-thumbs/s-block-carousel.png",
	"./s-cards-horz.png": "./admin-thumbs/s-cards-horz.png",
	"./s-checklist.png": "./admin-thumbs/s-checklist.png",
	"./s-companies.png": "./admin-thumbs/s-companies.png",
	"./s-company.png": "./admin-thumbs/s-company.png",
	"./s-contact-carousel.png": "./admin-thumbs/s-contact-carousel.png",
	"./s-cta.png": "./admin-thumbs/s-cta.png",
	"./s-downloads.png": "./admin-thumbs/s-downloads.png",
	"./s-events.png": "./admin-thumbs/s-events.png",
	"./s-facts-figures.png": "./admin-thumbs/s-facts-figures.png",
	"./s-header-large.png": "./admin-thumbs/s-header-large.png",
	"./s-header.png": "./admin-thumbs/s-header.png",
	"./s-hero.png": "./admin-thumbs/s-hero.png",
	"./s-highlights.png": "./admin-thumbs/s-highlights.png",
	"./s-hotspot.png": "./admin-thumbs/s-hotspot.png",
	"./s-image-slider.png": "./admin-thumbs/s-image-slider.png",
	"./s-image.png": "./admin-thumbs/s-image.png",
	"./s-link-grid.png": "./admin-thumbs/s-link-grid.png",
	"./s-link-list.png": "./admin-thumbs/s-link-list.png",
	"./s-list.png": "./admin-thumbs/s-list.png",
	"./s-logos.png": "./admin-thumbs/s-logos.png",
	"./s-lottie.png": "./admin-thumbs/s-lottie.png",
	"./s-number-carousel.png": "./admin-thumbs/s-number-carousel.png",
	"./s-post-carousel.png": "./admin-thumbs/s-post-carousel.png",
	"./s-post-header.png": "./admin-thumbs/s-post-header.png",
	"./s-quote.png": "./admin-thumbs/s-quote.png",
	"./s-stacking-cards.png": "./admin-thumbs/s-stacking-cards.png",
	"./s-text.png": "./admin-thumbs/s-text.png",
	"./s-video.png": "./admin-thumbs/s-video.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./admin-thumbs sync recursive \\.png$";